import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const courseParticipantQueryKey = (id) => ['courses', id, 'students']
export const useCourseParticipantsQuery = (id) =>
  useQuery({
    queryKey: courseParticipantQueryKey(id),
    queryFn: async () => {
      const { data } = await adminApi.getCourseParticipants(id)
      return data.data
    }
  })
